import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSession } from '../../auth/useSession.js';
import { listerAssocies } from '../../lib/api.js';

/**
 * Les comptes associés (`GET /v1/console/associes`). La clé porte l'id du
 * compte connecté : la liste en cache d'un autre compte n'est jamais servie.
 */
export function useAssocies() {
  const { moi } = useSession();
  const compteId = moi?.compte.id ?? null;
  const client = useQueryClient();
  const requete = useQuery({
    queryKey: ['console', 'associes', compteId],
    queryFn: listerAssocies,
  });
  return {
    comptes: requete.data ?? [],
    chargement: requete.isLoading,
    enErreur: requete.isError,
    relire: () => client.invalidateQueries({ queryKey: ['console', 'associes', compteId] }),
  };
}
